import { useEffect } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { useI18n } from "../i18n/LanguageContext";
import { api } from "../lib/api";
import { XCircle } from "lucide-react";

export default function CheckoutCancel() {
  const { t } = useI18n();
  const [params] = useSearchParams();
  const orderId = params.get("order_id");

  useEffect(() => {
    // Best-effort cancel the pending order so it doesn't stay pending forever.
    if (orderId) {
      api.cancelOrder(orderId).catch(() => {});
    }
  }, [orderId]);

  return (
    <div className="min-h-screen bg-[#FBF7EE] flex items-center justify-center p-6">
      <div className="w-full max-w-md rounded-[2rem] bg-white border-2 border-black/5 shadow-[0_30px_80px_rgba(0,0,0,0.10)] overflow-hidden" data-testid="checkout-cancel-page">
        <div className="p-8 bg-gradient-to-br from-[#FEF3C7] to-[#FEE2E2] text-center">
          <div className="mx-auto h-16 w-16 rounded-full bg-white text-[#7A4B00] grid place-items-center shadow">
            <XCircle className="h-9 w-9" />
          </div>
          <h1 className="mt-4 text-3xl font-black tracking-tight" data-testid="checkout-cancel-title">
            {t("unlock.checkoutCancelTitle")}
          </h1>
          <p className="mt-2 text-sm font-semibold text-black/70">
            {t("unlock.checkoutCancelBody")}
          </p>
        </div>

        <div className="p-6">
          <Link
            to="/dashboard"
            className="w-full rounded-full bg-[#1A1A1A] text-white font-bold px-6 py-3 shadow-[0_3px_0_#000] hover:translate-y-[1px] hover:shadow-[0_2px_0_#000] transition inline-flex items-center justify-center gap-2"
            data-testid="checkout-cancel-back"
          >
            {t("unlock.checkoutTakeMeBack")}
          </Link>
        </div>
      </div>
    </div>
  );
}
